import {
  CashFlowExpenseAccount,
  CashFlowIncomeOwner,
  ChangeCashFlowIncomeSelling,
  CashFlowIncomeBankAccount,
  CashFlowExpenseByDate,
  CashFlowExpenseFare,
  CashFlowExpenseSubReport,
  CashFlowExpenseSalary
} from '../components';

export enum TypeTemplates {
  CashFlowIncomeOwner = 0,
  ChangeCashFlowIncomeSelling = 1,
  CashFlowIncomeBankAccount = 2,
  CashFlowExpenseByDate = 3,
  CashFlowExpenseFare = 4,
  CashFlowExpenseSubReport = 5,
  CashFlowExpenseAccount = 6,
  CashFlowExpenseSalary = 7,
}
  


export const TYPE_TEMPLATE_COMPONENTS = {
  [TypeTemplates.CashFlowIncomeBankAccount]: CashFlowIncomeBankAccount,
  [TypeTemplates.ChangeCashFlowIncomeSelling]: ChangeCashFlowIncomeSelling,
  [TypeTemplates.CashFlowIncomeOwner]: CashFlowIncomeOwner,
  [TypeTemplates.CashFlowExpenseByDate]: CashFlowExpenseByDate,
  [TypeTemplates.CashFlowExpenseFare]: CashFlowExpenseFare,
  [TypeTemplates.CashFlowExpenseSubReport]: CashFlowExpenseSubReport,
  [TypeTemplates.CashFlowExpenseAccount]: CashFlowExpenseAccount,
  [TypeTemplates.CashFlowExpenseSalary]: CashFlowExpenseSalary,
}